// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channel-operators-config__operator-avatar {
    border-radius: 50%;
    width: 5.4rem !important;
    height: 5.4rem !important;
}

.channel-operators-config__operator-avatar svg {
    width: 100%;
    height: 100%;
}

.channel-operators-config__operator-priority {
    width: 100%;
    display: block;
    color: black;
    outline: none;
    padding: 0;
    margin: 0;
    margin-bottom: 1rem;
    border: none;
    border-bottom: 1px solid #9e9e9e;
    transition: box-shadow .3s, border .3s;
    font-size: 1.8rem;
}

.channel-operators-config__operator-name-cell {
    width: 14.4rem;
    height: 2.4rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: normal;
    word-break: break-word;
}

.channel-operators-config .modal-body {
    height: 54rem;
}

.channel-operators-config__operator-name {
    font-size: 1.8rem;
}

.channel-operators-config__operators__table {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 15px;
}

.channel-operators-config__filters-wrapper {
    margin-bottom: 20px;
}

.channel-operators-config__table-rows tr:first-child td {
    padding-top: 15px;
}
.channel-operators-config__operator-enable-cell {
    width: 5.4rem;
}

.channel-operators-config__operator-enable-cell [type="checkbox"] {
    position: fixed;
}

.channel-operators-config__operator-avatar-cell {
    width: 5.8rem;
}

.channel-operators-config .modal-title {
    width: 100%;
}

.channel-operators-config__header {
    display: flex;
    flex-direction: row;
}

.channel-operators-config__header .btn {
    margin-left: auto;
    background-color: #d22e37;
}

.channel-operators-config .modal-footer{
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.channel-operators-config__operator-priority-cell {
    width: 11rem;
}

.channel-operators-config__header-title {
    font-size: 2.4rem;
    font-weight: bold;
}

.channel-operators-config__filters {
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    align-items: center;
}

.channel-operators-config__filters .filter {
    width:45%;
}

.channel-operators-config__filters input.form-control {
    height: auto;
    margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/channel/channel-main/channel-list/channel-item/channel-operator-list/channel-operator-list-configuration/ChannelOperatorListConfiguration.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,aAAa;IACb,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".channel-operators-config__operator-avatar {\r\n    border-radius: 50%;\r\n    width: 5.4rem !important;\r\n    height: 5.4rem !important;\r\n}\r\n\r\n.channel-operators-config__operator-avatar svg {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.channel-operators-config__operator-priority {\r\n    width: 100%;\r\n    display: block;\r\n    color: black;\r\n    outline: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    margin-bottom: 1rem;\r\n    border: none;\r\n    border-bottom: 1px solid #9e9e9e;\r\n    transition: box-shadow .3s, border .3s;\r\n    font-size: 1.8rem;\r\n}\r\n\r\n.channel-operators-config__operator-name-cell {\r\n    width: 14.4rem;\r\n    height: 2.4rem;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    white-space: normal;\r\n    word-break: break-word;\r\n}\r\n\r\n.channel-operators-config .modal-body {\r\n    height: 54rem;\r\n}\r\n\r\n.channel-operators-config__operator-name {\r\n    font-size: 1.8rem;\r\n}\r\n\r\n.channel-operators-config__operators__table {\r\n    max-height: 400px;\r\n    overflow-y: auto;\r\n    padding-right: 15px;\r\n}\r\n\r\n.channel-operators-config__filters-wrapper {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.channel-operators-config__table-rows tr:first-child td {\r\n    padding-top: 15px;\r\n}\r\n.channel-operators-config__operator-enable-cell {\r\n    width: 5.4rem;\r\n}\r\n\r\n.channel-operators-config__operator-enable-cell [type=\"checkbox\"] {\r\n    position: fixed;\r\n}\r\n\r\n.channel-operators-config__operator-avatar-cell {\r\n    width: 5.8rem;\r\n}\r\n\r\n.channel-operators-config .modal-title {\r\n    width: 100%;\r\n}\r\n\r\n.channel-operators-config__header {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.channel-operators-config__header .btn {\r\n    margin-left: auto;\r\n    background-color: #d22e37;\r\n}\r\n\r\n.channel-operators-config .modal-footer{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n}\r\n\r\n.channel-operators-config__operator-priority-cell {\r\n    width: 11rem;\r\n}\r\n\r\n.channel-operators-config__header-title {\r\n    font-size: 2.4rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.channel-operators-config__filters {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 10px 15px;\r\n    align-items: center;\r\n}\r\n\r\n.channel-operators-config__filters .filter {\r\n    width:45%;\r\n}\r\n\r\n.channel-operators-config__filters input.form-control {\r\n    height: auto;\r\n    margin-top: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
